import { isPathExternal } from "../is-path-external/is-path-external";
import type { IOpenRoutePath } from "./open-route-path.interface";

export function openRoutePath({ path, navigate, currentPath }: IOpenRoutePath): void {
  if (!path) {
    return;
  }

  if (currentPath === path) {
    return;
  }

  if (isPathExternal(path)) {
    window.open(path, "_blank", "noreferrer noopener");
    return;
  }

  window.scrollTo({ top: 0, left: 0 });
  navigate(path, { state: { from: currentPath } });
}
